import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { PageHeaderComponent } from '../../../shared/ui/page-header/page-header.component';
import { AppointmentCreateFlowComponent } from '../components/appointment-create-flow.component';
import { AppointmentFormPrefill } from '../components/appointment-form.component';

@Component({
  selector: 'app-appointment-create-page',
  standalone: true,
  imports: [
    PageHeaderComponent,
    AppointmentCreateFlowComponent
  ],
  template: `
    <app-page-header
      title="Create Appointment"
      subtitle="Manual operational creation form"
    />

    <app-appointment-create-flow
      [prefill]="prefill"
      [navigateOnSuccess]="true"
    />
  `
})
export class AppointmentCreatePageComponent
{
  private readonly route = inject(ActivatedRoute);

  protected readonly prefill: AppointmentFormPrefill = {
    clinicId: this.route.snapshot.queryParamMap.get('clinicId') ?? '',
    deviceId: this.route.snapshot.queryParamMap.get('deviceId') ?? '',
    firstSlotId: this.route.snapshot.queryParamMap.get('firstSlotId') ?? '',
    firstSlotStartTime: this.route.snapshot.queryParamMap.get('firstSlotStartTime') ?? '',
    specialistUserId: this.route.snapshot.queryParamMap.get('specialistUserId') ?? ''
  };
}
